module.exports = __webpack_public_path__ + "static/img/advance_class.e0b4b9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/advance_class.png
// module id = rmj3
// module chunks = 1